import { Component, Input } from '@angular/core'
import { SafePipe } from '@app/shared/pipe/safe.pipe'
import { EnvService } from '@envs/env-service'
import { AuthService } from '@core/service/auth.service'
import { NavigationService } from '@core/service/navigation.service'

@Component({
  selector: 'app-deliverable-builder',
  templateUrl: './deliverable-builder.component.html',
  styleUrls: ['./deliverable-builder.component.scss'],
  providers: [SafePipe],
})
export class DeliverableBuilderComponent {
  @Input() id!: number
  @Input() deliverableId!: number
  @Input() changeRequestId?: number
  @Input() editLibDelEntryId!: number
  constructor(
    private envService: EnvService,
    private authService: AuthService,
    navigationService: NavigationService
  ) {
    navigationService.subscribeToNavigationMessages()
  }

  public get baseJsUrl(): string {
    const crPath = this.changeRequestId ? `/change-request/${this.changeRequestId}` : ''
    return `${this.envService.baseJsUrl}/scope-overview/${this.id}${crPath}/deliverable/${this.deliverableId}?editLibDelEntryId=${this.editLibDelEntryId}&childCompany=${this.authService.loggedInUser?.company.id}`
  }
}
